module.exports = ".p-category > a i {\n\tfont-size: 40px;\n\tmargin-top: 0px;\n}\n\n.p-category > a {\n\tpadding-bottom: 0px;\n}"